import { render, staticRenderFns } from "./BadgeListChemical.vue?vue&type=template&id=c9bfb37e&scoped=true&"
import script from "./BadgeListChemical.vue?vue&type=script&lang=js&"
export * from "./BadgeListChemical.vue?vue&type=script&lang=js&"
import style0 from "./BadgeListChemical.vue?vue&type=style&index=0&id=c9bfb37e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bfb37e",
  null
  
)

export default component.exports